<template>
  <SearchForm
    :baseApiUrl="baseApiUrl"
    :searchPage="searchPage"
    :texts="texts"
    :suggestSokOptions="suggestSokOptions"
    :idString="'headerSearch'"
    :selectedFilter="''"
    :sokFilter="[]"
    :useEntypoIcons="useEntypoIcons"
    @searchSubmitted="onSearchSubmitted"
  ></SearchForm>
</template>

<script>
import SearchForm from "./components/searchform.vue";

export default {
  name: "HeaderSearch",
  props: {
    baseApiUrl: String,
    searchPage: String,
    queryString: String,
    texts: Object,
    suggestSokOptions: Object,
    useEntypoIcons: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SearchForm,
  },
  methods: {
    onSearchSubmitted(urlParams) {
      // Navigera till sökresultatsidan med rätt querystring
      let searchUrl = this.searchPage || window.location.pathname;
      let qs = urlParams.toString();
      window.location.href = searchUrl + (qs ? ('?' + qs) : '');
    },
  },
};
</script>
